import { MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { trackEvent } from '@/lib/analytics';

interface WhatsAppButtonProps {
  onClick: () => void;
}

export const WhatsAppButton = ({ onClick }: WhatsAppButtonProps) => {
  return (
    <Button
      size="lg"
      className="fixed bottom-6 right-6 z-50 rounded-full w-14 h-14 shadow-float hover:scale-110 transition-transform bg-primary hover:bg-primary/90 p-0"
      onClick={() => {
        trackEvent('whatsapp_click', { location: 'floating_button' });
        onClick();
      }}
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle className="w-6 h-6 text-white" />
    </Button>
  );
};
